import { useIntl } from "react-intl";

const Analytics = () => {
    const intl = useIntl();

    const messages = {
        header: intl.formatMessage({
            id: "ConfluencePricingPage.features.Analytics.header",
            defaultMessage: "Analytics"
        }),
        content: intl.formatMessage({
            id: "ConfluencePricingPage.features.Analytics.content",
            defaultMessage:
                "Analytics lets you see user engagement and make more informed decisions with filters for the site, space, and page levels."
        }),
        altText: intl.formatMessage({
            id: "ConfluencePricingPage.features.Analytics.altText",
            defaultMessage: "Example of analytics"
        }),
        caption: intl.formatMessage({
            id: "ConfluencePricingPage.features.Analytics.caption",
            defaultMessage:
                "Here’s what the analytics overview looks like in Confluence."
        })
    };

    return (
        <>
            <h2>{messages.header}</h2>
            <p>{messages.content}</p>
            <img
                src="https://wac-cdn.atlassian.com/misc-assets/webp-images/Premium_feature_-_site_analytics-2X_2.webp"
                alt={messages.altText}
                height={350}
                loading="lazy"
            />
            <p>{messages.caption}</p>
        </>
    );
};

export default Analytics;
